export const AI_PERMISSION_KEYS = Object.freeze({
  chat: 'copilot:use',
  campaignStudio: 'aiStudio:campaigns:use',
  salesDocumentStudio: 'aiStudio:salesDocuments:use',
  documentStudio: 'aiStudio:documentStudio:use',
});

export const AI_STUDIO_PERMISSION_KEYS = Object.freeze([
  AI_PERMISSION_KEYS.campaignStudio,
  AI_PERMISSION_KEYS.salesDocumentStudio,
  AI_PERMISSION_KEYS.documentStudio,
]);
